import { render, staticRenderFns } from "./AllBays.vue?vue&type=template&id=b4c51582&scoped=true"
import script from "./AllBays.vue?vue&type=script&lang=js"
export * from "./AllBays.vue?vue&type=script&lang=js"
import style0 from "./AllBays.vue?vue&type=style&index=0&id=b4c51582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c51582",
  null
  
)

export default component.exports